module.exports = __webpack_public_path__ + "img/headphone.5f0ba802.svg";